export default __webpack_public_path__ + "static/media/digitalTechnology.970231df.pdf";